export const servicesVerticalCardsExperimentGroups = {
  control: 'control_horizont_scroll',
  test: 'test_vertical_scroll',
} as const;

export const servicesVerticalCardsExperimentName = 'mnz_vertical_scroll_261023';

type Val<T extends Object> = T[keyof T];

export type TServicesVerticalCardsExperimentGroupsNames = Val<typeof servicesVerticalCardsExperimentGroups>;
